module.exports = __webpack_public_path__ + "assets/c65a83eb78fa4a9ec41e52f919733d72.png";